import { createAction, createSlice } from '@reduxjs/toolkit';
import initialStateSucursal from '../../../domain/entities/sucursal';

function obtenerSucursalesExito(state, action) {
  const {responseSucursal } = action.payload;
  state.response = responseSucursal;
  state.responseError = false;
}

function obtenerSucursalesError(state, action){
  const {responseSucursal } = action.payload;
  state.response = responseSucursal;
  state.responseError = true;
}

function setSucursalSeleccionada(state, action) {
  state.sucursalSelected = action.payload;;
}

function saveSucursalSelectedSuccess(state, action){
  const {responseSaveSucursal } = action.payload;
  state.responseSave = responseSaveSucursal;
  state.responseSaveError = false;
}

function saveSucursalSelectedError(state){
  state.responseSave = null;
  state.responseSaveError = true;
}


const sucursalServicio = createAction('sucursalServicio');
const saveSucursal = createAction('saveSucursal');


const sucursalReducer = createSlice({
  name: 'sucursal',
  initialState: initialStateSucursal,
  reducers: {
    obtenerSucursalesExito,
    obtenerSucursalesError,
    setSucursalSeleccionada,
    saveSucursalSelectedSuccess,
    saveSucursalSelectedError,
  },
});

export const sucursalActions = {
  ...sucursalReducer.actions,
  sucursalServicio,
  saveSucursal,
}

export default sucursalReducer.reducer;